export default __webpack_public_path__ + "static/health-877f701e96a0ee3f5ff39c05ed9edbbe.png";